import { makeStyles } from '@mui/styles';
import { COLOR_WHITE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  researchToolContainer: {
    maxWidth: 1088,
    margin: 'auto',
    backgroundColor: '#E1EBFF',
    borderRadius: 12,
    padding: '15px 30px 30px',
    position: 'relative',
    color: '#051E57',
    fontFamily: 'Lato',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  limitedOffer: {
    background: '#1C4DC0',
    width: 148,
    padding: '6px 10px',
    fontSize: 12,
    lineHeight: '14px',
    borderRadius: 12,
    color: COLOR_WHITE,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  headContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  heading: {
    fontSize: 24,
    lineHeight: '38px',
    fontWeight: 400,
    margin: '14px 0 10px',
    maxWidth: '100%',
    [theme.breakpoints.down('md')]: {
      maxWidth: 620,
    },
  },
  skeleton: {
    width: 120,
    height: 16,
    display: 'inline-block',
    marginRight: 8,
  },
  subheading: {
    fontSize: 16,
    marginTop: 10,
    lineHeight: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: 3,
  },
  semiBold: {
    fontWeight: 600,
  },
  alignCenter: {
    display: 'flex',
    alignItems: 'center',
  },
  image: {
    position: 'absolute',
    right: '100px',
    top: '20px',
    [theme.breakpoints.down('md')]: {
      top: 45,
    },
  },
  productsContainer: {
    display: 'flex',
    marginTop: 25,
    background: 'var(--color-bg-white)',
    borderRadius: 'var(--border-radius-sm)',
    paddingTop: 15,
    paddingBottom: 15,
    position: 'relative',
    backgroundColor: COLOR_WHITE,
    borderRadius: 6,
  },
  // product: {
  //   maxWidth: 315,
  //   display: 'flex',
  //   flexDirection: 'column',
  //   gap: 4,
  //   fontFamily: 'var(--font-family-inter-regular)',
  //   fontSize: 'var(--font-size-sm)',
  //   lineHeight: '22px',
  //   position: 'relative',
  //   '&:not(:first-child)': {
  //     paddingLeft: 15,
  //     '&::after': {
  //       content: '""',
  //       position: 'absolute',
  //       top: 0,
  //       left: 0,
  //       width: 1,
  //       height: '100%',
  //       background: 'var(--color-primary-light-blue)',
  //     },
  //   },
  // },
  product: {
    maxWidth: 315,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    fontFamily: 'var(--font-family-inter-regular)',
    fontSize: 'var(--font-size-sm)',
    lineHeight: '22px',
    position: 'relative',
    paddingLeft: 15,
    paddingRight: 15,
  },

  productDivider: {
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: 1,
      height: '100%',
      background: '#5E96EF',
    },
  },
  productHeading: {
    display: 'flex',
    gap: 8,
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 500,
    alignItems: 'center',
  },
  productLogo: {
    background: '#EDF2FA',
    width: 32,
    height: 32,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
  },
  description: {
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400,
  },
}));
